import React, { useEffect, useState } from "react";
import Button from "../../../components/common/button/Button";
import { Form, Formik } from "formik";
import Input from "../../../components/common/inputs/Input";
import { postApi } from "../../../services/api/globalApi";
import { successMessage } from "../../../utils/toastify-message/ToastifyMessage";
import Select from "../../../components/common/inputs/Select";
import { studentSatisfactionVideValidation } from "../../../utils/validation/public-field/studentSatisfactionVideValidation";

function StudentSatisfactionVideo({ data }) {
  const [items, setItems] = useState([]);
  const [isActive, setIsActive] = useState(true);

  const addItem = (values, { resetForm }) => {
    setItems([...items, values]);
    resetForm();
  };

  const removeItem = (index) => {
    setItems(items.filter((_, i) => i !== index));
  };

  const saveItems = async () => {
    const path = "admin/publicFieldsForFrontUis";
    const body = { studentSatisfactionVideo: { value: items, isActive } };
    try {
      await postApi({ path, body });
      successMessage("ویدئو رضایت مشتریان با موفقیت ویرایش شد");
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    if (data) {
      setItems(data?.value || []);
      setIsActive(data?.isActive);
    }
  }, [data]);

  return (
    <div className="w-full py-4 px-4 border-r border-l">
      <Formik
        enableReinitialize
        initialValues={{
          videoUrl: "",
          image: "",
        }}
        validationSchema={studentSatisfactionVideValidation}
        onSubmit={addItem}
      >
        {(formik) => (
          <Form>
            <div className="grid gap-6 mb-4 md:grid-cols-2">
              <Input
                name="videoUrl"
                placeholder="ادرس ویدئو"
                label="ادرس ویدئو"
                type="text"
              />
              <Input
                name="image"
                placeholder="ادرس عکس"
                label="ادرس عکس"
                type="text"
              />
              <Select
                name="isActive"
                value={isActive}
                onChange={(e) => {
                  setIsActive(e.target.value);
                }}
                placeholder="فعال باشه؟"
                label="فعال باشه؟"
              >
                <option value={true}>بله</option>
                <option value={false}>خیر</option>
              </Select>
            </div>
            <div className="flex flex-col mt-8 gap-y-2">
              <Button
                text={"افزودن به لیست"}
                color={"primary"}
                onClick={formik.handleSubmit}
              />
            </div>
          </Form>
        )}
      </Formik>

      {/* Table to display added items */}
      <div className="mt-8">
        <table className="w-full border">
          <thead>
            <tr>
              <th className="border px-4 py-2">آدرس ویدئو</th>
              <th className="border px-4 py-2">آدرس عکس</th>
              <th className="border px-4 py-2">عملیات</th>
            </tr>
          </thead>
          <tbody>
            {items.map((item, index) => (
              <tr key={index}>
                <td className="border px-4 py-2">{item?.videoUrl}</td>
                <td className="border px-4 py-2">{item?.image}</td>
                <td className="border px-4 py-2">
                  <button
                    className="text-red-500"
                    onClick={() => removeItem(index)}
                  >
                    حذف
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className="flex justify-end mt-4">
          <Button
            text={"ذخیره تغییرات"}
            color={"success"}
            onClick={saveItems}
          />
        </div>
      </div>
    </div>
  );
}

export default StudentSatisfactionVideo;
